"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { twMerge } from "tailwind-merge";

import { getLinkTarget } from "@/globals";
import { BUTTON_STYLES } from "@/styles/buttons";
import { ErrorView } from "@/views/error.view";

export type NavItem = {
    href: string | undefined;
    label: string;
};

type NavItemFooterSecondaryProps = {
    navigationItem: NavItem;
};
export const NavItemFooterSecondaryView = ({ navigationItem }: NavItemFooterSecondaryProps) => {
    const currentPath = usePathname();

    if (navigationItem.href) {
        return (
            <li>
                <Link
                    href={navigationItem.href}
                    target={getLinkTarget(navigationItem.href)}
                    prefetch={false}
                    className={twMerge(
                        BUTTON_STYLES.footerNavigationSecondary(
                            navigationItem.href === currentPath,
                        ),
                    )}
                >
                    <span>{navigationItem.label}</span>
                </Link>
            </li>
        );
    } else {
        return (
            <li>
                <ErrorView>{navigationItem.label} </ErrorView>
            </li>
        );
    }
};
